import yup from '../config/yup/customYup';

export default yup
  .object({
    email: yup.string().email().required(),
  })
  .required();
